import * as Sentry from "@sentry/react";
import { useMemoizedFn } from "ahooks";
import { useEffect, useMemo } from "react";
import { ApiResponse, useFetcher } from "../common/useFetcher";
import { useApiSuspenseRequest } from "../common/useApiRequest";
import { useUserRoutes } from "./useUserRoutes";
// import { useUserMetrics } from "../sentry"; // Metrics 上报已禁用

export interface LoginPayload {
    username: string
    password: string
}

export interface UserInfo {
    user_id?: string
    nickname?: string
    username?: string
    phone?: string
    email?: string
}

export const useAuth = () => {
    const fetcher = useFetcher()
    const { refetch: refetchUserRoutes } = useUserRoutes()
    // const { recordLogin, recordLogout } = useUserMetrics() // Metrics 上报已禁用
    const { data: response, refetch } = useApiSuspenseRequest<ApiResponse<UserInfo>>({
        key: "getUserInfo",
        queryOptions: {
            refetchOnWindowFocus: false,
        }
    })

    const { isLogined, userInfo } = useMemo(() => {
        return {
            isLogined: response?.status === 0,
            userInfo: response?.data
        }
    }, [response])

    const logout = useMemoizedFn(async () => {
        await fetcher("logout")
        // recordLogout() // Metrics 上报已禁用
        window.location.reload()
    })

    const login = useMemoizedFn(async (payload: LoginPayload) => {
        // 记录登录开始时间 - Metrics 上报已禁用
        // loginStartTimeRef.current = performance.now()

        // const loginMethod = payload.phone ? "phone" : "password" // Metrics 上报已禁用
        // let success = false // Metrics 上报已禁用

        try {
            const response = await fetcher(
                [
                    'login',
                    payload
                ]
            ) as ApiResponse
            const { status, msg } = response
            if (status != 0) {
                throw new Error(msg)
            }
            await refetch()
            await refetchUserRoutes()
            // 刷新页面以重新触发根路由 beforeLoad，加载最新权限到 router context
            window.location.reload()
            // success = true // Metrics 上报已禁用
            return true
        } finally {
            // 计算登录耗时并记录 metrics - 已禁用
            // const durationMs = loginStartTimeRef.current
            //     ? performance.now() - loginStartTimeRef.current
            //     : undefined
            // recordLogin(loginMethod, success, durationMs)
            // loginStartTimeRef.current = null
        }
    })


    useEffect(() => {
        if (userInfo && userInfo?.user_id) {
            Sentry.setUser({
                id: userInfo?.user_id,
                username: userInfo?.nickname || userInfo?.phone, // 可选
                email: userInfo?.email,
            });
        } else {
            Sentry.setUser(null);
        }
    }, [userInfo]);


    return {
        isLogined,
        userInfo,
        logout,
        login
    }
}
